import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import leftArrow from "../../assets/images/ellipse-arrow-up.svg";
import rightArrow from "../../assets/images/ellipse-up-arrow.svg";
import CustomButton from "../form/CustomButton";
import { withRouter } from "../hoc/withRouter";

const onLeftClick = (props) => {
  if (props.noUrl) {
    props.loadData(props.page - 1);
  } else {
    if (props.page > 1) {
      const params = new URLSearchParams(props.history.location.search);
      params.set("p", props.page - 1);
      props.history(`${props.history.location.pathname}?${params}`);
    }
  }
};

const onNextClick = (props) => {
  if (props.noUrl) {
    props.loadData(props.page + 1);
  } else {
    if (props.page < props.pageCount) {
      const params = new URLSearchParams(props.history.location.search);
      params.set("p", props.page + 1);
      props.history(`${props.history.location.pathname}?${params}`);
    }
  }
};

const Pagination = (props) => {
  const [inputPage, setInputPage] = useState(props.page);

  useEffect(() => {
    setInputPage(props.page);
  }, [props.page]);


  const handleInputChange = (e) => {
    const value = e.target.value;

    // allow only numbers using regex
    if (/^\d*$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputBlur = () => {
    let pageNum = parseInt(inputPage, 10);

    if (!pageNum || pageNum < 1) {
      pageNum = 1;
    } else if (pageNum > props.pageCount) {
      pageNum = props.pageCount;
    }

    // update url or loadData
    if (props.noUrl) {
      props.loadData(pageNum);
    } else {
      const params = new URLSearchParams(props.history.location.search);
      params.set("p", pageNum);
      props.history(`${props.history.location.pathname}?${params}`);
    }
  };

  return (
    <div className="pagination-wrapper">
      <CustomButton
        handleClick={() => onLeftClick(props)}
        buttonImage={leftArrow}
        className="left-arrow"
      />

      <div className="page-input-wrapper">
        <input
          type="text"
          value={inputPage}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          className="page-input"
        />
        <span> of {props.pageCount}</span>
      </div>

      <CustomButton
        handleClick={() => onNextClick(props)}
        buttonImage={rightArrow}
        className="right-arrow"
      />
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  loadData: PropTypes.func,
  noUrl: PropTypes.bool,
  history: PropTypes.object,
};

export default withRouter(Pagination);
